'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CloseButtonIcon() {
  return _react2.default.createElement(_decisivIconixReact2.default, { modifiers: ['mini'], name: 'close' });
}

exports.default = CloseButtonIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Tag/CloseButtonIcon.js
// module id = 1613
// module chunks = 2